/* @flow strict */

import * as React from 'react';
import _ from 'lodash';

import './styles.scss';

type PropsType = {
  name: string,
  id: string,
  label?: string | React.Node,
  style?: {},
  withAddon?: string | React.Node,
  addonPosition?: string,
  type?: string,
  placeholder?: string,
  onChange?: (e) => void,
  onFocus?: (e) => void,
  onBlur?: (e) => void,
  value?: any,
  validator?: {
    text?: string | React.Node
  } | boolean,
  forceShowValidator?: boolean,
  dataId?: string,
  readonly?: boolean,
  classes?: {
    input?: string
  },
  minLength?: string | number,
  maxLength?: number,
  isShowLimit?: boolean,
  limit?: number,
  limitOffset?: number,
  limitCb?: (string) => void,
  disabled?: boolean,
  dataTestid?: string
};

const SimpleInput = (props: PropsType): React.Element<'div'> => {
  let isShowValMsg = false; // props.validator && (!props.value || props.value.toString().length < 1);
  const _validator = props.validator; // _.size(props.validator) > 0;
  const { limitOffset = 0 } = props;
  const [isShowLimitLabel, toggleShowLimitLabel] = React.useState(false);
  const [isShowLimitWarning, toggleShowLimitWarning] = React.useState(false);

  if (_validator) {
    if (!_.has(props, 'value') || props.value.toString().length < 1 || props.forceShowValidator || isShowLimitWarning) {
      isShowValMsg = true;
    }
  }

  return (
    <div className="form-group SimpleInput" style={props.style ? { ...props.style } : {}}>
      {props.label ? <label htmlFor={props.id}>{props.label}</label> : null}
      {!props.withAddon ?
        <>
          <input
            required={_validator}
            className={`
              ${_.get(props, 'classes.input', 'form-control')}
              ${isShowValMsg ? ' validationElement' : ''}
              SimpleInput-${props.id}
            `}
            type={props.type ? props.type : 'text'}
            name={props.name}
            id={props.id}
            data-id={props.dataId}
            value={props.value ? `${props.value}` : ''}
            placeholder={props.placeholder ? props.placeholder : ''}
            onChange={(e: any) => {
              if (props.isShowLimit) {
                toggleShowLimitWarning(_.size(e.target.value) - limitOffset > props.limit);

                if (_.size(e.target.value) - limitOffset > props.limit) {
                  // props.limitCb(props.id);
                  props.limitCb(`SimpleInput-${props.id}`);
                } else {
                  // props.limitCb(props.id, 0);
                  props.limitCb(`SimpleInput-${props.id}`, 1);
                }
              }

              if (props.onChange) {
                props.onChange(e);
              }
            }}
            onFocus={(e: any) => {
              if (props.onFocus) {
                props.onFocus(e);
              }

              if (props.isShowLimit) {
                toggleShowLimitLabel(true);
              }
            }}
            onBlur={(e: any) => {
              if (props.onBlur) {
                props.onBlur(e);
              }

              if (props.isShowLimit) {
                toggleShowLimitLabel(false);
              }
            }}
            readOnly={props.readonly}
            minLength={props.minLength}
            maxLength={!!props.maxLength ? props.maxLength + limitOffset : ''}
            disabled={!!props.disabled}
            data-testid={!!props.dataTestid ? props.dataTestid : 'SimpleInput_input'}
            min={props.type === 'number' ? '0' : ''}
          />

          {props.isShowLimit && isShowLimitLabel &&
            <span className='SimpleInput__limitPlaceholder'>{_.size(props.value) - limitOffset}/{props.limit}</span>
          }

          {(_validator) &&
            <div className='vMsg' style={{ display: isShowValMsg ? 'block' : 'none' }}>
              <>
                {isShowLimitWarning ?
                  <>Please enter no more than {props.limit} characters.</> :
                  <>
                    {_.get(props, 'validator.text', false) ?
                      <>{props.validator.text}</> :
                      <>This field is required.</>
                    }
                  </>
                }
              </>
            </div>
          }
        </> :
        <>
          <div className="input-group">
            {props.addonPosition === 'start' &&
              <span className="input-group-addon">
                <span className="symbol">{props.withAddon}</span>
              </span>
            }

            <input
              required={_validator}
              className={`
                ${_.get(props, 'classes.input', 'form-control')}
                ${isShowValMsg ? ' validationElement' : ' '}
                SimpleInput-${props.id}
              `}
              type={props.type ? props.type : 'text'}
              name={props.name}
              id={props.id}
              data-id={props.dataId}
              value={props.value ? props.value : ''}
              placeholder={props.placeholder ? props.placeholder : ''}
              onChange={(e: any) => {
                if (props.isShowLimit) {
                  toggleShowLimitWarning(_.size(e.target.value) - limitOffset > props.limit);

                  if (_.size(e.target.value) - limitOffset > props.limit) {
                    props.limitCb(`SimpleInput-${props.id}`);
                  } else {
                    props.limitCb(`SimpleInput-${props.id}`, 1);
                  }
                }

                if (props.onChange) {
                  props.onChange(e);
                }
              }}
              onFocus={(e: any) => {
                if (props.onFocus) {
                  props.onFocus(e);
                }

                if (props.isShowLimit) {
                  toggleShowLimitLabel(true);
                }
              }}
              onBlur={(e: any) => {
                if (props.onBlur) {
                  props.onBlur(e);
                }

                if (props.isShowLimit) {
                  toggleShowLimitLabel(false);
                }
              }}
              readOnly={props.readonly}
              disabled={!!props.disabled}
              data-testid={!!props.dataTestid ? props.dataTestid : 'SimpleInput_input'}
              min={props.type === 'number' ? '0' : ''}
            />

            {props.isShowLimit && isShowLimitLabel &&
              <span
                className='SimpleInput__limitPlaceholder SimpleInput__limitPlaceholder-addons'
              >
                {_.size(props.value) - limitOffset}/{props.limit}
              </span>
            }

            {props.addonPosition === 'end' &&
              <span className="input-group-addon">
                <span className="symbol">{props.withAddon}</span>
              </span>
            }
          </div>
          {(_validator) &&
            <div className='vMsg' style={{ display: isShowValMsg ? 'block' : 'none' }}>
              <>
                {isShowLimitWarning ?
                  <>Please enter no more than {props.limit} characters.</> :
                  <>
                    {_.get(props, 'validator.text', false) ?
                      <>{props.validator.text}</> :
                      <>This field is required.</>
                    }
                  </>
                }
              </>
            </div>
          }
        </>
      }

    </div>
  );
};

export default SimpleInput;
